var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.currentDayTemplate)?_c('TimeConstraintList',{attrs:{"constrainedItem":_vm.currentDayTemplate && _vm.currentDayTemplate,"timeConstraintType":_vm.timeConstraintType,"allow-period-selection":false}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }